/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAgentMyConnectionsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type GetAgentMyConnectionsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Email address of the enrolled user, sent in the Gram-User-Email header. Required when authenticating with an org-scoped agent install key; ignored for a per-user key, whose owner is the enrolled user.
   */
  gramUserEmail?: string | undefined;
};

/** @internal */
export type GetAgentMyConnectionsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAgentMyConnectionsSecurity$outboundSchema: z.ZodMiniType<
  GetAgentMyConnectionsSecurity$Outbound,
  GetAgentMyConnectionsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function getAgentMyConnectionsSecurityToJSON(
  getAgentMyConnectionsSecurity: GetAgentMyConnectionsSecurity,
): string {
  return JSON.stringify(
    GetAgentMyConnectionsSecurity$outboundSchema.parse(
      getAgentMyConnectionsSecurity,
    ),
  );
}

/** @internal */
export type GetAgentMyConnectionsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-User-Email"?: string | undefined;
};

/** @internal */
export const GetAgentMyConnectionsRequest$outboundSchema: z.ZodMiniType<
  GetAgentMyConnectionsRequest$Outbound,
  GetAgentMyConnectionsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramUserEmail: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramUserEmail: "Gram-User-Email",
    });
  }),
);

export function getAgentMyConnectionsRequestToJSON(
  getAgentMyConnectionsRequest: GetAgentMyConnectionsRequest,
): string {
  return JSON.stringify(
    GetAgentMyConnectionsRequest$outboundSchema.parse(
      getAgentMyConnectionsRequest,
    ),
  );
}
